import React, {createContext, useContext, useEffect, useState} from "react";
import {COOKIE_KEY, THEME} from "../constants";
import {ITheme} from "../types";
import {Cookies} from "react-cookie";
import {DarkTheme, LightTheme} from "../assets";
import {App, ConfigProvider} from "antd";
import {ThemeConfig} from "antd/es/config-provider/context";

const cookies = new Cookies();

const initialState: ITheme = {
  theme: THEME.LIGHT,
  handleToggleTheme: () => {
  },
  themeConfig: LightTheme
}

const ThemeContext = createContext<ITheme>(initialState);

export const ThemeProvider = ({children}: any) => {
  const [theme, setTheme] = useState<THEME>(cookies.get(COOKIE_KEY.THEMES) || THEME.LIGHT)
  const [themeConfig, setThemeConfig] = useState<ThemeConfig | undefined>(theme === THEME.LIGHT ? LightTheme : DarkTheme)

  useEffect(() => {
    const themeHandler = (options: any) => {
      if (options.name === COOKIE_KEY.THEMES && options.value) {
        setTheme(options.value)
      }
    }

    cookies.addChangeListener((options) => {
      themeHandler(options)
    })

    return () => {
      cookies.removeChangeListener((options) => {
        themeHandler(options)
      })
    }
  }, [])

  const handleToggleTheme = () => {
    if (theme === THEME.DARK) {
      cookies.set(COOKIE_KEY.THEMES, THEME.LIGHT, {path: '/'})
      setThemeConfig(LightTheme)
    } else {
      cookies.set(COOKIE_KEY.THEMES, THEME.DARK, {path: '/'})
      setThemeConfig(DarkTheme)
    }
  }

  return (
    <ThemeContext.Provider value={{theme, handleToggleTheme, themeConfig}}>
      <ConfigProvider theme={themeConfig}>
        <App>
          {children}
        </App>
      </ConfigProvider>
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)